import React, { useState } from 'react';
import { HelpIcon } from '../../icons';
import { useTutorialContext } from '../../contexts/TutorialContext';
import KeyboardShortcutsModal from './KeyboardShortcutsModal';

const HelpBubble: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { state: tutorialState } = useTutorialContext();

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  // Check if transcript-editing tutorial has been shown (completed or skipped)
  const transcriptEditingShown = tutorialState.shown.has('transcript-editing');

  // Don't show the help bubble if there's an active tutorial or transcript-editing tutorial hasn't been shown
  if (tutorialState.currentTutorial || !transcriptEditingShown) {
    return null;
  }

  return (
    <>
      {/* Floating Help Bubble */}
      <button
        onClick={handleOpenModal}
        className="fixed bottom-6 left-6 z-40 w-10 h-10 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center group"
        title="Keyboard Shortcuts & Quick Actions"
        aria-label="Open help and keyboard shortcuts"
      >
        <HelpIcon
          size={26}
          className="group-hover:scale-110 transition-transform"
        />
      </button>

      {/* Keyboard Shortcuts Modal */}
      <KeyboardShortcutsModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default HelpBubble;
